import { Button } from "@mui/material";

import { StyledButton, StyledCloseOutline } from "../styles";
import { EditViewToggleProps } from "../types";

export const EditViewToggle = ({ editView, setEditView }: EditViewToggleProps) => {
  if (!editView) {
    return (
      <Button
        className="button"
        onClick={() => {
          setEditView(true);
        }}
      >
        Edit
      </Button>
    );
  }

  return (
    <StyledButton
      className="button"
      onClick={() => {
        setEditView(false);
      }}
    >
      <StyledCloseOutline />
    </StyledButton>
  );
};
